module.exports = __webpack_public_path__ + "static/media/checkbox_normal_desktop.fc19326e.svg";